export const PHASES_RESET_STATE = 'PHASES_RESET_STATE';
export const PHASES_CURRENT_ITEM = 'PHASES_CURRENT_ITEM';

export const PHASES_REQUEST_LOADING = 'PHASES_REQUEST_LOADING';
export const PHASES_REQUEST_SUCCESS = 'PHASES_REQUEST_SUCCESS';
export const PHASES_REQUEST_FAILED = 'PHASES_REQUEST_FAILED';

export const PHASES_CURRENT_ACTION = 'PHASES_CURRENT_ACTION';
export const PHASES_RESET_ACTION = 'PHASES_RESET_ACTION';